import { useTranslation } from 'react-i18next'
import {
  MessageSquare,
  AlertTriangle,
  TrendingDown,
  TrendingUp,
  Minus,
} from 'lucide-react'
import { cn } from '@/lib/utils'
import type { IntelReportKPI } from '../model/contracts'

interface KpiCardProps {
  icon: React.ReactNode
  label: string
  value: number
  className?: string
}

function KpiCard({ icon, label, value, className }: KpiCardProps) {
  return (
    <div
      className={cn(
        'flex flex-1 flex-col gap-2 rounded-xl border border-border p-4 shadow-sm',
        className,
      )}
    >
      <div className="flex items-center gap-2">
        {icon}
        <span className="text-xs font-medium">{label}</span>
      </div>
      <span className="text-2xl font-bold">{value}</span>
    </div>
  )
}

interface IntelKpiStripProps {
  kpi: IntelReportKPI
}

export function IntelKpiStrip({ kpi }: IntelKpiStripProps) {
  const { t } = useTranslation('intel')

  return (
    <div className="flex flex-wrap gap-3">
      <KpiCard
        icon={<MessageSquare className="size-4" />}
        label={t('kpi.totalComments')}
        value={kpi.totalComments}
        className="bg-card text-foreground"
      />
      <KpiCard
        icon={<AlertTriangle className="size-4" />}
        label={t('kpi.harshActionRequired')}
        value={kpi.harshActionRequired}
        className="bg-destructive/10 text-destructive"
      />
      <KpiCard
        icon={<TrendingDown className="size-4" />}
        label={t('kpi.negative')}
        value={kpi.negative}
        className="bg-sentiment-negative-surface text-sentiment-negative"
      />
      <KpiCard
        icon={<TrendingUp className="size-4" />}
        label={t('kpi.positive')}
        value={kpi.positive}
        className="bg-sentiment-positive-surface text-sentiment-positive"
      />
      <KpiCard
        icon={<Minus className="size-4" />}
        label={t('kpi.neutral')}
        value={kpi.neutral}
        className="bg-card text-foreground"
      />
    </div>
  )
}
